import React, { useState } from 'react';
import { MONTHS } from '../../data/seasonalContent';
import '../../styles/explore.scss';

function MonthGuide() {
	const [active, setActive] = useState(10); // October — peak season
	const month = MONTHS.find((m) => m.num === active);

	return (
		<div className="month-guide">
			<div className="month-guide__tabs" role="tablist" aria-label="Month by month">
				{MONTHS.map((m) => (
					<button
						key={m.num}
						type="button"
						role="tab"
						className={`month-guide__tab${active === m.num ? ' is-active' : ''}`}
						aria-selected={active === m.num}
						onClick={() => setActive(m.num)}
					>
						{m.name.slice(0, 3)}
					</button>
				))}
			</div>
			{month && (
				<div className="month-guide__panel" role="tabpanel">
					<div>
						<h3 className="month-guide__summary">{month.name}: {month.summary}</h3>
						<p className="month-guide__detail"><strong>Trekking:</strong> {month.trekking}</p>
						<p className="month-guide__detail"><strong>Wildlife:</strong> {month.wildlife}</p>
					</div>
					<div>
						<p className="month-guide__detail"><strong>Festivals:</strong> {month.festivals}</p>
						<p className="month-guide__detail"><strong>Season:</strong> {month.season.charAt(0).toUpperCase() + month.season.slice(1)}</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default MonthGuide;
